<section
  class="insertion-panel"
  role="dialog"
  [attr.aria-label]="
    mode === 'token' ? 'Insert registered token' : 'Insert supported block'
  "
  (keydown)="close($event)"
>
  <div class="insertion-heading">
    <h3>{{ mode === "token" ? "Insert token" : "Insert block" }}</h3>
    <button
      uiButton="secondary"
      type="button"
      (click)="close()"
      [attr.aria-label]="mode === 'token' ? 'Close tokens' : 'Close insertion'"
    >
      Close
    </button>
  </div>
  <div class="insertion-controls">
    @if (mode === "token") {
      <label>
        Search tokens
        <input
          #initialControl
          uiControl
          type="search"
          name="page-token-search"
          autocomplete="off"
          [disabled]="disabled"
          [ngModel]="tokenSearch"
          (ngModelChange)="changeTokenSearch($event)"
        />
      </label>
      <label>
        Reference type
        <select
          uiControl
          name="page-token-kind"
          [disabled]="disabled"
          [ngModel]="tokenKind"
          (ngModelChange)="changeTokenKind($event)"
        >
          <option value="field">Data field</option>
          <option value="term">Terminology</option>
        </select>
      </label>
      <p class="insertion-count" role="status">
        {{ tokenOptions.length }} matching
        {{ tokenOptions.length === 1 ? "token" : "tokens" }}
      </p>
      <label>
        Token
        <select
          uiControl
          name="page-token-code"
          [disabled]="disabled || !tokenOptions.length"
          [ngModel]="selectedToken?.code ?? ''"
          (ngModelChange)="changeTokenCode($event)"
        >
          <option value="" disabled>
            {{ tokenOptions.length ? "Choose a token" : "No matching tokens" }}
          </option>
          @for (token of tokenOptions; track token.code) {
            <option [value]="token.code">
              {{ token.label }} · {{ token.code }}
            </option>
          }
        </select>
      </label>
      @if (selectedToken; as token) {
        <dl class="insertion-metadata">
          <dt>Binding</dt>
          <dd>{{ tokenKind === "field" ? "Data field" : "Terminology" }}</dd>
          <dt>Code</dt>
          <dd>
            <code>{{ token.code }}</code>
          </dd>
          @if (!tokenFormats.length) {
            <dt>Format</dt>
            <dd>Default</dd>
          }
        </dl>
        @if (tokenFormats.length) {
          <label>
            Format
            <select
              uiControl
              name="page-token-format"
              [disabled]="disabled"
              [ngModel]="tokenFormats.includes(tokenFormat) ? tokenFormat : ''"
              (ngModelChange)="changeTokenFormat($event)"
            >
              @if (!tokenFormats.includes(tokenFormat)) {
                <option value="" disabled>Choose a format</option>
              }
              @for (format of tokenFormats; track format) {
                <option [value]="format">{{ format }}</option>
              }
            </select>
          </label>
        }
      } @else if (!tokenOptions.length) {
        <p class="insertion-guidance">
          No registered tokens match. Change the search or reference type.
        </p>
      }
      <button
        uiButton="primary"
        type="button"
        [disabled]="!canInsertToken"
        (click)="requestToken()"
      >
        Insert at caret
      </button>
    } @else {
      <label>
        Block type
        <select
          #initialControl
          uiControl
          name="page-block-kind"
          [disabled]="disabled"
          [ngModel]="insertionKind"
          (ngModelChange)="changeInsertionKind($event)"
        >
          <option value="paragraph">Text</option>
          <option value="box">Box</option>
          <option value="repeat" [disabled]="!canAddTable">
            Repeating table
          </option>
          <option value="pageBreak">Page break</option>
        </select>
      </label>
      <label>
        Position
        <select
          uiControl
          name="page-block-position"
          [disabled]="disabled"
          [ngModel]="insertionPosition"
          (ngModelChange)="changeInsertionPosition($event)"
        >
          <option value="before">Before selection</option>
          <option value="after">After selection</option>
        </select>
      </label>
      <p class="insertion-anchor">
        {{ insertionPosition === "before" ? "Before" : "After" }}
        {{ selectedLabel || "selection required" }}
      </p>
      <p class="insertion-guidance">
        {{ blocksUsed }} / {{ blockLimit }} blocks · Page breaks need content on
        both sides.
      </p>
      <button
        uiButton="primary"
        type="button"
        [disabled]="!canInsertBlock"
        (click)="requestBlock()"
      >
        Insert
      </button>
    }
  </div>
</section>
